<template>

    <div class="container">
        
        <app-head :title="__('Alle Angebote für :product', {product: product.name})" />

        <div class="mt-5 mb-3">
            <breadcrumbs :items="breadcrumbs" />
        </div>

        <div class="my-4">
            <h1>{{ product.name }}</h1>
        </div>

        <form class="mb-5">
            <div class="row align-items-center">
                <div class="col-md-6">
                    <span class="h4 m-0 text-primary">
                        {{ __(':count Angebote', {count: offers.length}) }} 
                        <template v-if="filteredOffers.length">
                            {{ __('ab :price', {price: $options.filters.localizeAmount(lowestPrice)}) }}
                        </template>
                    </span>
                </div>
                <div class="col-md-6">
                    <div class="d-flex gap-5">
                        <text-input type="search" label="Filter Lieferant" class="w-100" v-model="form.search" />
                        <select-input label="Sortieren nach" class="w-100" v-model="form.order_by">
                            <option :value="k" v-for="(v, k) in orderByOptions">{{ v }}</option>
                        </select-input>
                    </div>
                </div>
            </div>
        </form>

        <section class="mb-5">

            <div class="row">
                <div class="col-4">{{ __('Lieferant') }}</div>
                <div class="col-4">{{ __('Angebot') }}</div>
                <div class="col-4"></div>
            </div>
            <hr />

            <div v-if="filteredOffers.length === 0">
                {{ __('Keine Angebote') }}
            </div>
            <div v-else v-for="(product, index) in filteredOffers" :key="product.id">

                <div class="row align-items-center">

                    <div class="col-4">
                        <h5>
                            <inertia-link :href="route('suppliers.show', product.supplier)" class="link-dark">
                                {{ product.supplier.name }}
                            </inertia-link>
                        </h5>
                    </div>
                    <div class="col-4">
                        
                        <template v-if="product.optimal_price">
                            <div class="fw-bold">
                                {{ __('ab :price', {price: $options.filters.localizeAmount(product.optimal_price.price)}) }}
                            </div>
<!--                        @todo    <div class="text-black-50">
                                {{ __('ab :lowerBound Stck.', {lowerBound: $options.filters.localizeNumber(product.optimal_price.lower_bound)}) }}
                            </div>-->
                        </template>

                        <div class="text-black-50" v-if="product.price_hint">
                            {{ product.price_hint }}
                        </div>

                        <div>
                            <tax-info :product="product" />
                            <delivery-info :product="product" />
                        </div>
                    </div>
                    <div class="col-4 text-end">
                        <div class="">
                            <inertia-link
                                :href="route('cart.add-item', product)"
                                :data="{quantity: 1}"
                                as="button"
                                type="button"
                                method="post"
                                class="btn btn-lg btn-primary text-white"
                                v-if="$page.props.auth.user.can.add_cart_items">
                                <i class="bi bi-cart"></i>
                                {{ __('In den Warenkorb') }}
                            </inertia-link>
                        </div>
                    </div>
                </div>

                <hr />

            </div>

        </section>

        <section v-if="similarProducts.length">
            <heading title="Ähnliche Produkte">
            </heading>
            <product-teasers :products="similarProducts" />
        </section>

    </div>

</template>

<script>
    import Heading from '@/shared/Heading';
    import Quantity from '@/shared/Quantity';
    import Breadcrumbs from '@/shared/Breadcrumbs';
    import ProductTeasers from '@/shared/ProductTeasers';
        import TaxInfo from '@/shared/TaxInfo';
    import DeliveryInfo from '@/shared/DeliveryInfo';
    import TextInput from '@/shared/Inputs/TextInput';
    import SelectInput from '@/shared/Inputs/SelectInput';

    export default {
        props: [
            'product',
            'category',
            'offers',
            'lowestPrice',
            'similarProducts',
        ],
        data() {
            return {
                form: {
                    search: '',
                    order_by: 'price_asc',
                },
                orderByOptions: {
                    price_asc: this.__('Preis aufsteigend'),
                    price_desc: this.__('Preis absteigend'),
                    supplier_name: this.__('Lieferant'),
                },
                breadcrumbs: [
                    {url: this.route('categories.index'), label: this.__('Categories')},
                    {url: this.route('categories.show', this.category.path), label: this.category.name},
                            // @todo neue permalinks {url: this.route('products.show', this.product), label: this.product.name},
                ]
            }
        },
        components: {
            Heading,
            Quantity,
            Breadcrumbs,
            ProductTeasers,
            TaxInfo,
            DeliveryInfo,
            TextInput,
            SelectInput,
        },
        computed: {
            filteredOffers() {
                return this.offers.filter(item => {
                    let query = this.form.search.toLowerCase();
                    return item.supplier.slug.toLowerCase().indexOf(query) > -1 || item.supplier.name.toLowerCase().indexOf(query) > -1
                })
            }
        }
    }
</script>